import React, { Component, PropTypes } from 'react';
import partial from 'lodash/partial';
import truncate from 'lodash/truncate';
import classnames from 'classnames';
import { WEIGHT_OPTIONS } from 'presentations/constants';
import AddParticipantsModal from 'presentations/containers/add_participants_modal';

export default class Participants extends Component {
  constructor(props) {
    super(props);

    this.updateWeight = this.updateWeight.bind(this);
    this.remove = this.remove.bind(this);
    this.resendInvite = this.resendInvite.bind(this);
  }

  updateWeight(participant, e) {
    this.props.update(participant.id, { weight: parseInt(e.target.value) });
  }

  remove(participant, e) {
    this.props.remove(participant.id);
  }

  resendInvite(participant, e) {
    this.props.resendInvite(participant.id);
  }

  renderRow(participant) {
    const { presentation } = this.props;
    const votedClass = classnames("fa", {
      "fa-check-circle has-voted text-success": !!participant.last_voted_at,
      "fa fa-times text-danger": !participant.last_voted_at
    });

    return (
      <tr key={participant.id}>
        <td className="participant-email">
          <span className="show-for-small-only">
            { truncate(participant.email, { length: presentation.weight_votes? 10 : 20 }) }
          </span>
          <span className="hide-for-small-only">{ participant.email }</span>
        </td>

        { presentation.weight_votes &&
        <td>
          <div className="form-group">
            <div className="select-wrapper">
              <select className="form-control" value={participant.weight}
                  onChange={partial(this.updateWeight, participant)}>
                { WEIGHT_OPTIONS.map((option, i) => (
                  <option key={i} value={option.field}>{option.label}</option>
                )) }
              </select>
            </div>
          </div>
        </td> }

        <td className="text-center hide-for-small-only"><i className={votedClass} /></td>

        <td className="actions">
          <button onClick={partial(this.remove, participant)} className="btn btn-text btn-md">
            Remove
          </button>
          <div className="separator hide-for-small-only">|</div>
          <button onClick={partial(this.resendInvite, participant)}
              className="btn btn-text btn-md">
            { participant.inviteResent? 'Invitation Resent!' : 'Resend Invitation' }
          </button>
        </td>
      </tr>
    );
  }

  render() {
    const { presentation, participants, toggleAddModal } = this.props;

    return (
      <div className="tab-content participants">
        <div className="tab-actions">
          <button className="btn btn-secondary btn-sm " onClick={toggleAddModal}>
            Add Participants
          </button>
        </div>
        <table className="table table-default participants-table">
          <thead>
            <tr>
              <td>Email</td>
              { presentation.weight_votes && <td>Vote Counts</td> }
              <td className="center hide-for-small-only">Has Voted</td>
              <td />
            </tr>
          </thead>
          <tbody>
            { participants.map(participant => this.renderRow(participant)) }
          </tbody>
        </table>
        <AddParticipantsModal />
      </div>
    );
  }
}

Participants.propTypes = {
  update: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  resendInvite: PropTypes.func.isRequired,
  toggleAddModal: PropTypes.func.isRequired,
  presentation: PropTypes.object.isRequired,
  participants: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./presentations/components/participants.jsx